module.exports = __webpack_public_path__ + "img/List_background3.d1e74468.png";